import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import axios from 'axios';
import UploadPage from './UploadPage';
import CenteredTabs from './User';
import Admin from './Admin';
import TeamLeader from './TeamLeader';
import TestTable from './TestTable';
import apiBaseUrl from './API'

// import Snackbar from '@material-ui/core/Snackbar';
// import MuiAlert from '@material-ui/lab/Alert';

// import Drawer from 'material-ui/Drawer';
// import MenuItem from 'material-ui/MenuItem';

class Login extends Component {
  constructor(props){
    super(props);
    var localloginComponent=[];

    
    localloginComponent.push(
      <MuiThemeProvider key={"theme"}>
        <div>
         <TextField
           hintText="Enter your College Rollno"
           floatingLabelText="Student Id"
           onChange={(event,newValue) => this.setState({username:newValue})}
           />
         <br/>
           <TextField
             type="password"
             hintText="Enter your Password"
             floatingLabelText="Password"
             onChange = {(event,newValue) => this.setState({password:newValue})}
             />
           <br/>
           <RaisedButton label="Submit" primary={true} style={style} onClick={(event) => this.handleClick(event)}/>
       </div>
       </MuiThemeProvider>
    )
    this.state={
      username:'',
      password:'',
      loginComponent:localloginComponent,
    }
  }
  componentWillMount(){

      console.log("Will mount");
      var localloginComponent=[];
      localloginComponent.push(
        <MuiThemeProvider>
          <div>
           <TextField
             hintText="Email ID"
             floatingLabelText="Email ID"
             onChange = {(event,newValue) => this.setState({username:newValue})}
             />
           <br/>
             <TextField
               type="password"
               hintText="Enter your Password"
               floatingLabelText="Password"
               onChange = {(event,newValue) => this.setState({password:newValue})}
               />
             <br/>
             <RaisedButton label="Submit" primary={true} style={style} onClick={(event) => this.handleClick(event)}/>
         </div>
         </MuiThemeProvider>
      )
      this.setState({loginComponent:localloginComponent})
  
  }
  handleClick(event){
    var self = this;
    var payload={
      "userid":this.state.username,
	    "password":this.state.password,
    }
    axios.post(apiBaseUrl+'/login', payload)
   .then(function (response) {
     console.log(" ress ",response);
     console.log(" ress 1",response.data.res[0].id);

      console.log(self.state.loginRole)
     if(response.data.code == 200){
       if(response.data.res[0].role == "user"){
      //   <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      //   <Alert onClose={handleClose} severity="success">
      //     This is a success message!
      //   </Alert>
      // </Snackbar>
       console.log("Login successfull");
       var uploadScreen=[];
       uploadScreen.push(<CenteredTabs userid = {response.data.res[0].id} tlid = {response.data.res[0].tl_id} appContext={self.props.appContext} role={self.state.loginRole}/>)
       self.props.appContext.setState({loginPage:[],uploadScreen:uploadScreen})
       }else if(response.data.res[0].role == "admin"){
          var uploadScreen=[];
          uploadScreen.push(<Admin userid = {response.data.res[0].id} appContext={self.props.appContext} role={self.state.loginRole}/>)
          self.props.appContext.setState({loginPage:[],uploadScreen:uploadScreen})
       }else if(response.data.res[0].role == "tl"){
       //  <TestTable/>
        var uploadScreen=[];
        uploadScreen.push(<TeamLeader userid = {response.data.res[0].id} tlid = {response.data.res[0].tl_id} appContext={self.props.appContext} role={self.state.loginRole}/>)
        self.props.appContext.setState({loginPage:[],uploadScreen:uploadScreen})
        // var uploadScreen=[];
        // uploadScreen.push(<TestTable userid = {response.data.res[0].id} appContext={self.props.appContext} role={self.state.loginRole}/>)
        // self.props.appContext.setState({loginPage:[],uploadScreen:uploadScreen})
     }
     }
    //  else if(response.data.code == 204){
    //    console.log("Username password do not match");
    //    alert(response.data.success)
    //  }
     else{
       console.log("Username does not exists");
       alert("Username does not exist");
     }
   })
   .catch(function (error) {
     console.log(error);
   });
  }
   render() {
    return (
      <div>
        <MuiThemeProvider>
        <AppBar
             title="Login"
             
           />
            {/* <Drawer
            open={this.state.open}
            width={200}
            containerStyle={styles.navBar}>
            <MenuItem>Menu Item</MenuItem>
            <MenuItem>Menu Item 2</MenuItem>
          </Drawer> */}
        </MuiThemeProvider>
     
        {this.state.loginComponent}
      </div>
    );
  }
}

const style = {
  margin: 15,
};

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js